import React, { useEffect, useRef } from 'react';
import { fetchActiveMobile, queryActiveMobileCaptchaCode } from 'lib/apis';
import SMSCode from 'lib/components/SMSCode';
import Dialog from 'lib/components/Dialog';
import { CAPTCHA_LENGTH } from 'lib/constants/operator';
import TipsModal from 'lib/components/Modal/TipsModal';
import { closeModal, showModal } from 'lib/components/Modal';
import toast from 'lib/utils/toast';
import { ERROR_MSG, COMMON_MSG } from 'lib/constants/error';
import { useCountDown } from 'lib/hooks/useCountDown';
import storage from 'lib/utils/storage';
import { STORAGE } from 'lib/utils/storage/constants';
import userOrderService from 'lib/services/userOrderService';
import channelService from 'lib/services/channelService';
import CountDown from '../SMSCaptchaModal/CountDown';
import './index.scss';

const ActiveMobile = ({ mobile }) => {
  const requestIdRef = useRef(storage.getStorage(STORAGE.SMSCODE_ORDER_ID));
  const isSubmit = useRef(false);
  const isAutoSend = useRef(false);
  const { countdown, startCountDown } = useCountDown(`active${mobile}`);

  useEffect(() => {
    if (!mobile) return;
    if (countdown === null) return;
    if (countdown > 0) {
      isAutoSend.current = true;
      return;
    }
    !isAutoSend.current && fetchActiveMobileCaptchaCode();
  }, [mobile, countdown]);

  const fetchActiveMobileCaptchaCode = async () => {
    if (countdown) return;
    toast.loading();
    const res = await queryActiveMobileCaptchaCode(mobile);
    toast.close();
    if (res?.code !== 0) {
      TipsModal.show({
        content: ERROR_MSG[res?.code] || COMMON_MSG,
      });
      return;
    }
    const expireTime = startCountDown(60);
    const { requestId } = res?.data || {};
    storage.setStorage(STORAGE.SMSCODE_ORDER_ID, requestId, expireTime);
    requestIdRef.current = requestId;
  };

  const submit = async (code) => {
    if (isSubmit.current) return;
    isSubmit.current = true;
    toast.loading();
    const res = await fetchActiveMobile({
      mobile,
      smsCode: code,
      requestId: requestIdRef.current,
    });
    toast.close();
    isSubmit.current = false;
    if (res?.code !== 0) {
      toast.info(ERROR_MSG[res?.code] || COMMON_MSG);
      return;
    }
    toast.info('绑定成功');
    closeModal();
    await userOrderService.handleUserOrderInfo(channelService.channelCode);
  };
  return (
    <Dialog title="绑定游戏账号">
      <div className="active-mobile">
        <div className="active-mobile__content">
          验证码已发送至<span className="mask-mobile">{mobile.replace(/(\d{3})\d{4}(\d{3})/, '$1****$2')}</span>手机中
        </div>
        <div className="active-mobile__tips">一经绑定无法修改</div>
        <SMSCode codeLength={CAPTCHA_LENGTH.NORMAL} submit={submit} smsModalTheme="common" />
        <CountDown countdown={countdown} resendCode={fetchActiveMobileCaptchaCode} />
      </div>
    </Dialog>
  );
};

export const showActiveMobile = (props) => showModal(<ActiveMobile {...props} />);

export default ActiveMobile;
